import PropTypes from 'prop-types';
import styled from 'styled-components';

import { get } from 'styles/utils';

const sizes = { xs: '36rem', sm: '45rem', md: '64rem', lg: '75rem' };

const Container = styled.div.attrs(({ size, ...props }) => ({
  $size: size,
  ...props,
}))`
  margin-left: auto;
  margin-right: auto;
  position: relative;
  max-width: 100%;

  ${(p) => p.$size && `width: ${get(sizes, p.$size, p.$size)};`}
`;

Container.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
    PropTypes.string,
  ]),
};

Container.defaultProps = {
  size: 'lg',
};

export default Container;
